import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TOLL_EXTRAORDINARY_ASSIGNMENT_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import TollExtraordinaryAssignmentForm from './TollExtraordinaryAssignmentForm';
import { postTollExtraordinaryAssignment } from '../../../../actions';
import { utcDayBoundary } from '../../../../utils/date';

const NewTollExtraordinaryAssignment = ({
  breadcrumbs,
  dispatchPostTollExtraordinaryAssignment,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = {
      serviceTypeIds: formValues.serviceTypeIds.map(({ value }) => value),
      routeId: formValues.routeId.value,
      startDate: utcDayBoundary({ date: formValues.startDate, time: 'start' }),
      endDate: utcDayBoundary({ date: formValues.endDate, time: 'end' }),
      tollIds: formValues.tollIds.map(({ value }) => value),
    };

    dispatchPostTollExtraordinaryAssignment(newFormValues);
  };

  const content = <TollExtraordinaryAssignmentForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Peaje Extraordinario Asignado"
      subtitle="Crear nueva asignación de peajes extraordinarios"
      content={content}
    />
  );
};

NewTollExtraordinaryAssignment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostTollExtraordinaryAssignment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostTollExtraordinaryAssignment: postTollExtraordinaryAssignment,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Peajes Extraordinarios Asignados',
      href: TOLL_EXTRAORDINARY_ASSIGNMENT_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewTollExtraordinaryAssignment);
